/**
 * DOC HELPER — Canvas semantic-map pending overlay.
 *
 * Adds a presentation-only running state while an explicit artifact save
 * request is in flight. It does not decide canonical workflow state.
 */

function text(value) {
  return String(value ?? '').trim();
}

export function withSemanticMapPending(tabs = [], pending = false) {
  const items = Array.isArray(tabs) ? tabs : [];
  if (!pending) {
    return items;
  }
  return items.map((tab) => {
    if (text(tab?.key) !== 'requirement') {
      return tab;
    }
    const views = Array.isArray(tab?.artifact_views) ? tab.artifact_views : [];
    let hasSemanticMapView = false;
    const artifactViews = views.map((view) => {
      if (!['semantic_map', 'smart_structure'].includes(text(view?.key || view?.view_key))) {
        return view;
      }
      hasSemanticMapView = true;
      return {
        ...view,
        status: 'refreshing',
        running: true,
      };
    });
    return {
      ...tab,
      ...(views.length > 0 ? { artifact_views: hasSemanticMapView ? artifactViews : views } : {}),
      running: true,
      status: 'updating',
    };
  });
}

export default withSemanticMapPending;
